import React from 'react';
import { APP_BEYOND_URL } from '../../tracker.constants';

export default class PackageTrackingIframeWithoutTrackingKey extends React.Component {
  componentDidMount() {
    const app = document.getElementById('root').parentElement;

    const appBackground = document.querySelector('.app-background');
    if (appBackground) {
      appBackground.style.background = 'none';
    }

    app.innerHTML = `
      <iframe 
        src="${APP_BEYOND_URL}/rastreador" 
        style="width:100vw; height:100vh; border:0; overflow:hidden;" 
      />
    `;

    window.addEventListener('message', this.handleMessage);
  }

  handleMessage = event => {
    if (event.origin === APP_BEYOND_URL) {
      const { action, url } = event.data;
      if (action === 'exitByAppLoggiIframe' && url) {
        window.location.replace(url);
      }
    }
  };

  render() {
    return null;
  }
}

PackageTrackingIframeWithoutTrackingKey.displayName =
  'PackageTrackingIframeWithoutTrackingKey';
